import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Radix Select can't hold "" as a value, so "no doctor" needs a stand-in.
const NONE = "__none__";

/* The doctor a bill is for. The invoice prints this doctor's name, registration
 * number and signature, so it is a pick from the doctor list, never free text. */
export function DoctorSelect({ value, onChange, testId }) {
  const [doctors, setDoctors] = useState([]);
  useEffect(() => {
    api.get("/users", { params: { role: "doctor" } }).then((r) => setDoctors(r.data || [])).catch(() => {});
  }, []);
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder="Select doctor" /></SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>No doctor</SelectItem>
        {doctors.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
